import React, { useEffect, useState } from 'react';
import { Table, Tooltip, Radio } from 'antd';
import PropTypes from 'prop-types';
import {
  cellViewImportantField,
  cellViewValueField,
  cellViewClusterMeanField
} from '../components/TableCellView';
import { TableViewContainer } from './styled';
import { floor, orderBy } from '../../../util/lodashlike';
import Locked from '../../../assets/mandatoryLock.svg';
import unLocked from '../../../assets/mandatoryUnlocked.svg';

import style from './index.scss';
import { hasAttributeValue } from '../../../util';
import { getSelectedResources } from '../../../util/resourceManager';

const { trmResources } = getSelectedResources();

const TableView = ({
  tableData = [],
  enableClusterMean = false,
  legendText = '',
  mandatoryScoringCondition,
  authentication
}) => {
  const [mandatoryState, setMandatoryState] = useState();
  const THRESHOLD_VIEW_ACCESS = hasAttributeValue(
    authentication,
    trmResources.APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS,
    'Threshold'
  );
  useEffect(() => {
    setMandatoryState(mandatoryScoringCondition);
  }, [mandatoryScoringCondition]);

  const columns = THRESHOLD_VIEW_ACCESS
    ? [
        {
          title: '',
          dataIndex: 'isMandatory',
          render: (value) => <img src={value ? Locked : unLocked} />
        },
        {
          title: 'Risk Indicator',
          dataIndex: 'name'
        },
        {
          title: 'Threshold',
          dataIndex: 'threshold',
          render: (value) => (
            <Tooltip title={value}>
              <span>{floor(value, 2)}</span>
            </Tooltip>
          )
        },
        {
          title: 'Value',
          render: (data) => cellViewValueField(data, enableClusterMean)
        },
        {
          title: 'Importance',
          render: (data) => cellViewImportantField(data)
        }
      ]
    : [
        {
          title: '',
          dataIndex: 'isMandatory',
          render: (value) => <img src={value ? Locked : unLocked} />
        },
        {
          title: 'Risk Indicator',
          dataIndex: 'name'
        },
        {
          title: 'Value',
          render: (data) => cellViewValueField(data, enableClusterMean)
        },
        {
          title: 'Importance',
          render: (data) => cellViewImportantField(data)
        }
      ];

  if (enableClusterMean) {
    columns.splice(2, 0, {
      title: 'Cluster Mean',
      render: (data) => cellViewClusterMeanField(data)
    });
  }

  const pagination = {
    total: tableData.length,
    showTotal: (total, range) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
        <li style={{ marginRight: '10px', fontSize: '12px' }}>
          Legend:{' '}
          <span>
            <img src={Locked} alt="lock" />
          </span>{' '}
          Mandatory risk indicator &nbsp;
          <span>
            ( &nbsp;
            <Radio.Group size="small" onChange={''} value={mandatoryState}>
              <Radio value="and" disabled={mandatoryState !== 'and'}>
                AND
              </Radio>
              <Radio value="or" disabled={mandatoryState !== 'or'}>
                OR
              </Radio>
            </Radio.Group>
            )
          </span>
        </li>
        <span>{`${total} Records`}</span>
      </div>
    ),
    defaultCurrent: 1,
    defaultPageSize: 15,
    itemRender: (current, type, originalElement) => {
      if (type === 'prev' || type === 'next') {
        return originalElement;
      }
      return <li>{originalElement}</li>;
    }
  };

  return (
    <TableViewContainer>
      <Table
        className={style.antdTableContainer}
        style={{ marginTop: '40px', marginLeft: '35px' }}
        pagination={pagination}
        bordered
        dataSource={orderBy(tableData, ['importance'], ['desc'])}
        columns={columns}
      />
    </TableViewContainer>
  );
};

TableView.propTypes = {
  tableData: PropTypes.array,
  enableClusterMean: PropTypes.bool
};

export default TableView;
